import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import Filter_icon from "../../assets/images/filter_icon.png";
import Rectangle from "../../assets/images/Rectangle.png";
import Info_icon from "../../assets/images/info_icon.png";
import UnionIcon from "../../assets/images/icons/Union_5.svg";
import Close from "../../assets/images/close.png";
import { useTranslation } from "react-i18next";
import space__icon from "../../assets/images/space__icon.png";
import SearchJewelryDataService from "../../services/search-jewelry.service";
import CatalogJewelryDataService from "../../services/catalog-jewelry.service";
import useCurrencyRate from "../../helper/useCurrencyRate";
import {
  setManageInventoryVendorId,
  setManageTabName,
  setVendorProfilePageName,
} from "../../actions/Community/ManageInventory";

import {
  Button,
  Col,
  Input,
  Modal,
  Pagination,
  Select,
  Slider,
  Spin,
  Table,
  Tooltip,
} from "antd";

//Initial Watch Data
const myWatchData = {
  category: "",
  materialType: "",
  genderSelect: "",
  vendor: "",
  materialColor: "",
  gemstone: "",
  collectionSelect: "",
  priceMin: 0,
  priceMax: 1000000,
};
const getDefaultWatchData = () => ({
  category: "",
  materialType: "",
  genderSelect: "",
  vendor: "",
  materialColor: "",
  gemstone: "",
  collectionSelect: "",
  priceMin: 0,
  priceMax: 1000000,
});

const { Option } = Select;

const JewelrySearch = () => {
  const { t } = useTranslation();
  const { Search } = Input;
  const loginDetials = useSelector((state) => state.loginReducer);
  const [state, setState] = useState({
    productChange: {},
  });
  const [viewItem, setViewItem] = useState("grid");
  const [hideShowFilter, setHideShowFilter] = useState(true);

  const [filterWatchValue, setfilterWatchValue] = useState(getDefaultWatchData);
  const [dealerId, setDealerId] = useState();
  const currency = useSelector((state) => state.loginReducer.currency);
  const currencySymbol =
    currency && currency.substring(currency.lastIndexOf("-") + 1);
  const currencySign = useSelector((state) => state.loginReducer.currencySign);
  // Slider
  const currencyRate = useCurrencyRate(dealerId);
  const priceSliderMax = Math.round(1000000 * currencyRate);
  const [priceValue, setPriceValue] = useState([0, 1000000]);
  useEffect(() => {
    setPriceValue((prev) => [prev[0], prev[1] >= 1000000 ? Math.round(1000000 * currencyRate) : prev[1]]);
  }, [currencyRate]);
  const [selectedColumnId, setSelectedColumnId] = useState(0);
  const [loading, setLoading] = useState(false);
  const tableTopRef = useRef(null);
  const [metalTypesList, setMetalTypesList] = useState([]);
  const [metalColorsList, setMetalColorsList] = useState([]);
  const [gendersList, setGendersList] = useState([]);
  const [categoryList, setProductCategoryList] = useState([]);
  const [vendorsList, setVendorsList] = useState([]);
  const [collectionList, setCollectionList] = useState([]);
  const [gemstoneList, setGemstoneList] = useState([]);
  const [viewALLProductList, setViewALLProductList] = useState([]);
  const [jewelryTotalRecords, setJewelryTotalRecords] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [sortType, setSortType] = useState("ASC");
  const [sortColumnName, setSortColumnName] = useState("GT.MODIFIED");
  const [key, setKey] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalImgSrc, setModalImgSrc] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [AttributesSets, setAttributesSets] = useState([]);
  const [selectDrp, setSelectDrp] = useState(null);
  const [filterBtnVisble, setFilterBtnVisble] = useState(true);
  const [btnValue, setBtnValue] = useState(1);
  const [priceValueChange, setPriceValueChange] = useState(false);
  const { Option, OptGroup } = Select;
  const dispatch = useDispatch();

  //Onchange Event
  const handleOnChange = (eValue, name) => {
    setfilterWatchValue({
      ...filterWatchValue,
      [name]: eValue,
    });
    handleGetJewelryDataList(dealerId.toString(), "", name, "");
  };

  const handleViewMore = (id) => {
    dispatch(setManageTabName("Manage"));
    dispatch(setManageInventoryVendorId(id));
    dispatch(setVendorProfilePageName("Profile"));
    setTimeout(() => {
      window.open("/vendorProfile", "_blank");
    }, 1000);
  };

  /*Slider Min Max Values Starts*/
  const onSliderChange = (eValue, name) => {
    setPriceValue(eValue);
    setfilterWatchValue({
      ...filterWatchValue,
      price: eValue,
    });
  };
  /*Slider Min Max Values Ends*/
  //Apply Filters
  const applyFilters = () => {
    setHideShowFilter(true);
    handleViewALLProduct(
      1,
      15,
      dealerId,
      filterWatchValue.category.length == 0 ? "" : filterWatchValue.category,
      filterWatchValue.vendor.length == 0 ? "" : filterWatchValue.vendor,
      filterWatchValue.materialType.length == 0
        ? ""
        : filterWatchValue.materialType,
      filterWatchValue.genderSelect.length == 0
        ? ""
        : filterWatchValue.genderSelect,
      filterWatchValue.collectionSelect.length == 0
        ? ""
        : filterWatchValue.collectionSelect,
      filterWatchValue.materialColor.length == 0
        ? ""
        : filterWatchValue.materialColor,
      filterWatchValue.price,
      sortColumnName,
      sortType,
      filterWatchValue.gemstone.length == 0 ? "" : filterWatchValue.gemstone,
      searchValue
    );
  };

  const onChangeMultiDrop = (e, name) => {
    let isRemove = false;
    if (e.length > filterWatchValue[name].length) {
      isRemove = false;
    } else {
      isRemove = true;
    }

    setSelectDrp(name);
    setFilterBtnVisble(false);
    let tempState = filterWatchValue;
    if (e.includes("")) {
      tempState[name] = [];
      tempState[name].push("");
    } else {
      tempState[name] = e;
    }
    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
    handleGetJewelryDataList(dealerId.toString(), "", name, "");
  };

  const onKeyPressEvent1 = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!new RegExp("[0-9.]").test(keyValue)) event.preventDefault();
    return;
  };

  const firstSliderPriceValue = (e, num) => {
    setPriceValueChange(true);

    setFilterBtnVisble(false);
    let newArr = [...priceValue];
    var Value = e.target.value && e.target.value.replace(currencySymbol, "");

    if (
      Number(parseFloat(Value.replace(/,/g, ""))) > priceSliderMax
    ) {
      e.preventDefault();
    } else if (Number(num) == 0) {
      if (Value == "" || Value == " ") {
        newArr[0] = 0;
        setPriceValue(newArr);
      } else {
        var NewValue = Value.replace(" ", "");
        newArr[0] = Number(parseFloat(NewValue.replace(/,/g, "")));
        setPriceValue(newArr);
      }
    } else if (Number(num) == 1) {
      if (Value == "" || Value == " ") {
        newArr[1] = 0;
        setPriceValue(newArr);
      } else {
        var NewValue = Value.replace(" ", "");
        newArr[1] = Number(parseFloat(NewValue.replace(/,/g, "")));
        setPriceValue(newArr);
      }
    }
  };

  //Reset Filters
  const resetFilters = () => {
    setfilterWatchValue(myWatchData);
    setSortColumnName("GT.MODIFIED");
    setSortType("ASC");
    setKey(!key);
    setSearchValue("");
    var obj = priceValue;
    obj[0] = filterWatchValue.priceMin;
    obj[1] = priceSliderMax;
    setPriceValue([filterWatchValue.priceMin, priceSliderMax]);
    handleViewALLProduct(
      1,
      15,
      dealerId,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "GT.MODIFIED",
      "ASC",
      "",
      ""
    );

    let tempState = filterWatchValue;
    tempState["category"] = [];
    tempState["materialType"] = [];
    tempState["genderSelect"] = [];
    tempState["vendor"] = [];
    tempState["materialColor"] = [];
    tempState["gemstone"] = [];
    tempState["collectionSelect"] = [];
    clearSearchFilter();
  };

  const gender = (
    <span>
      {t(
        "Gender is not a required field for vendor data, so by leaving this blank, the majority of product results will be considered Ladies."
      )}
    </span>
  );

  const collection = (
    <span> {t("Please select a vendor before choosing a collection.")} </span>
  );

  const handleProductChangeOpen = (gfInventoryID) => {
    state.productChange = {};
    state.productChange[gfInventoryID] = true;
    setState((prevState) => ({
      ...prevState,
      ...state,
    }));
  };

  const handleProductChangeClose = (gfInventoryID) => {
    state.productChange = {};
    state.productChange[gfInventoryID] = false;
    setState((prevState) => ({
      ...prevState,
      ...state,
    }));
  };

  const handleHideShowFilter = () => {
    setHideShowFilter(!hideShowFilter);
  };

  const handleViewChange = (viewname) => {
    setViewItem(viewname);
  };

  //Table Rows Checkbox Logic
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setfilterWatchValue(getDefaultWatchData());
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetJewelryDataList(
            loginDetials.loginDetials.responseData.dealerId.toString(),
            "",
            "",
            ""
          );
          handleViewALLProduct(
            pageNo,
            pageSize,
            loginDetials.loginDetials.responseData.dealerId,
            filterWatchValue.category,
            filterWatchValue.vendor,
            filterWatchValue.materialType,
            filterWatchValue.genderSelect,
            filterWatchValue.collectionSelect,
            filterWatchValue.materialColor,
            filterWatchValue.price,
            "GT.MODIFIED",
            "ASC",
            filterWatchValue.gemstone,
            ""
          );
        }
      }
    }
  }, []);

  /*API Binding Starts*/

  const handleGetALLJewelryDataList = async (vendor = "") => {
    try {
      let inputData = {
        orderby: "GFInventoryID",
        order: "ASC",
        category: "",
        vendor: vendor || "",
        materialType: "",
        gender: "",
        collection: "",
        collectionID: "",
        materialColor: "",
        minRange: 0,
        maxRange: 0,
        styleNumber: "",
        dealerType: "All",
        noOfRows: 0,
        offset: 0,
        gemstoneType: "",
        strSelectedInvID: "",
        image: "",
      };
      await SearchJewelryDataService.GetALLJewelryDataList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var metalTypesList = response.data.responseData.metalTypes;
          var metalColorsList = response.data.responseData.metalColors;
          if (message === "Success") {
            if (responseData) {
              setMetalTypesList(metalTypesList);
              setMetalColorsList(metalColorsList);
            } else {
              setMetalTypesList([]);
              setMetalColorsList([]);
            }
          } else {
            setMetalTypesList([]);
            setMetalColorsList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetALLJewelryDataListSecond = async (vendor = "") => {
    try {
      let inputData = {
        orderby: "GFInventoryID",
        order: "ASC",
        category: "",
        vendor: vendor || "",
        materialType: "",
        gender: "",
        collection: "",
        collectionID: "",
        materialColor: "",
        minRange: 0,
        maxRange: 0,
        styleNumber: "",
        dealerType: "All",
        noOfRows: 0,
        offset: 0,
        gemstoneType: "",
        strSelectedInvID: "",
        image: "",
      };
      await SearchJewelryDataService.GetALLJewelryDataListSecond(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var gendersList = response.data.responseData.genders;
          if (message === "Success") {
            if (responseData) {
              setGendersList(gendersList);
            } else {
              setGendersList([]);
            }
          } else {
            setGendersList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetProductCategoryList = async (vendor = "") => {
    try {
      let inputData = {
        orderby: "GFInventoryID",
        order: "ASC",
        category: "",
        vendor: vendor || "",
        materialType: "",
        gender: "",
        collection: "",
        collectionID: "",
        materialColor: "",
        minRange: 0,
        maxRange: 0,
        styleNumber: "",
        dealerType: "All",
        noOfRows: 0,
        offset: 0,
        gemstoneType: "",
        strSelectedInvID: "",
        image: "",
      };
      await SearchJewelryDataService.GetProductCategoryList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var jewelryCategoryList =
            response.data.responseData.jewelryCategoryList;
          if (message === "Success") {
            if (responseData) {
              setProductCategoryList(jewelryCategoryList);
            } else {
              setProductCategoryList([]);
            }
          } else {
            setProductCategoryList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetALLJewelryDataListCollections = async (vendor = "") => {
    try {
      let inputData = {
        orderby: "GFInventoryID",
        order: "ASC",
        category: "",
        vendor: vendor || "",
        materialType: "",
        gender: "",
        collection: "",
        collectionID: "",
        materialColor: "",
        minRange: 0,
        maxRange: 0,
        styleNumber: "",
        dealerType: "All",
        noOfRows: 0,
        offset: 0,
        gemstoneType: "",
        strSelectedInvID: "",
        image: "",
      };
      await SearchJewelryDataService.GetALLJewelryDataListCollections(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var collectionsList = response.data.responseData.collections;
          if (message === "Success") {
            if (responseData) {
              setCollectionList(collectionsList);
            } else {
              setCollectionList([]);
            }
          } else {
            setCollectionList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetALLJewelryDataListGemstoneTypes = async () => {
    try {
      let inputData = {
        orderby: "GFInventoryID",
        order: "ASC",
        category: "",
        vendor: "",
        materialType: "",
        gender: "",
        collection: "",
        collectionID: "",
        materialColor: "",
        minRange: 0,
        maxRange: 0,
        styleNumber: "",
        dealerType: "All",
        noOfRows: 0,
        offset: 0,
        gemstoneType: "",
        strSelectedInvID: "",
        image: "",
      };
      await SearchJewelryDataService.GetALLJewelryDataListGemstoneTypes(
        inputData
      )
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var gemstoneTypesList = response.data.responseData.gemstoneTypes;
          if (message === "Success") {
            if (responseData) {
              setGemstoneList(gemstoneTypesList);
            } else {
              setGemstoneList([]);
            }
          } else {
            setGemstoneList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetALLJewelryDataListVendorname = async () => {
    try {
      let inputData = {
        orderby: "GFInventoryID",
        order: "ASC",
        category: "",
        vendor: "",
        materialType: "",
        gender: "",
        collection: "",
        collectionID: "",
        materialColor: "",
        minRange: 0,
        maxRange: 0,
        styleNumber: "",
        dealerType: "All",
        noOfRows: 0,
        offset: 0,
        gemstoneType: "",
        strSelectedInvID: "",
        image: "",
      };
      await SearchJewelryDataService.GetALLJewelryDataListVendornameforjewelrysearch(
        inputData
      )
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var vendorsList = response.data.responseData.vendors;
          if (message === "Success") {
            if (responseData) {
              setVendorsList(vendorsList);
            } else {
              setVendorsList([]);
            }
          } else {
            setVendorsList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleViewALLProduct = async (
    no,
    size,
    id,
    category,
    vendor,
    materialtype,
    gender,
    collection,
    materialcolor,
    price,
    columnName,
    sortby,
    gemstone,
    val
  ) => {
    setPageNo(no);
    setPageSize(size);
    setLoading(true);
    try {
      let inputData = {
        orderby: "GFInventoryID",
        dealerID: id,
        pageNumber: no,
        order: "ASC",
        category: category.toString(),
        gemstone: gemstone.toString(),
        vendor: vendor.toString(),
        materialType: materialtype.toString(),
        gender: gender.toString(),
        collection: collection.toString(),
        collectionIDs: "",
        materialColor: materialcolor.toString(),
        minRange: priceValue ? priceValue[0].toString() : "",
        maxRange: priceValue ? priceValue[1].toString() : "",
        styleNumber: val ? val : "",
        dealerType: "search",
        noOfRows: size + "",
        offset: "0",
        strSelectedInvID: "",
        hasImage: "true",
        viewBy: "2",
        orderby: columnName ? columnName.toString() : sortColumnName,
        order: sortby ? sortby.toString() : sortType,
      };

      await SearchJewelryDataService.ViewALLProduct(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData?.length > 0) {
              setViewALLProductList(responseData);
              setJewelryTotalRecords(responseData[0].jewelryTotalRecords);
              setLoading(false);
            } else {
              setViewALLProductList([]);
              setLoading(false);
              setJewelryTotalRecords(0);
            }
          } else {
            setViewALLProductList([]);
            setLoading(false);
            setJewelryTotalRecords(0);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  /*API Binding Ends*/
  function scrollToTop() {
    var allElements = document.querySelectorAll('div');
    allElements.forEach(function(el) {
      if (el.scrollTop > 0) {
        el.scrollTop = 0;
      }
    });
    window.scrollTo(0, 0);
    if (tableTopRef.current) {
      tableTopRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }

  function handlePageNoChange(page, pageSize) {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    if (pageNo !== page) {
      setPageNo(page);
      setTimeout(scrollToTop, 100);
      handleViewALLProduct(
        page,
        pageSize,
        dealerId,
        filterWatchValue.category,
        filterWatchValue.vendor,
        filterWatchValue.materialType,
        filterWatchValue.genderSelect,
        filterWatchValue.collectionSelect,
        filterWatchValue.materialColor,
        filterWatchValue.price,
        sortColumnName,
        sortType,
        filterWatchValue.gemstone
      );
    }
  }
  function handlePageSizeChange(current, size) {
    if (pageSize !== size) {
      setPageSize(size);
      handleViewALLProduct(
        pageNo,
        size,
        dealerId,
        filterWatchValue.category,
        filterWatchValue.vendor,
        filterWatchValue.materialType,
        filterWatchValue.genderSelect,
        filterWatchValue.collectionSelect,
        filterWatchValue.materialColor,
        filterWatchValue.price,
        sortColumnName,
        sortType,
        filterWatchValue.gemstone
      );
    }
  }

  const handleTableASCDES = (pagination, filters, sorter) => {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    setTimeout(scrollToTop, 100);
    var type = "";
    var column = "";

    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "ASC";
      column = "GT.MODIFIED";
      setSortColumnName(column);
      setSortType(type);
    }

    handleViewALLProduct(
      pagination.current,
      pagination.pageSize,
      dealerId,
      filterWatchValue.category,
      filterWatchValue.vendor,
      filterWatchValue.materialType,
      filterWatchValue.genderSelect,
      filterWatchValue.collectionSelect,
      filterWatchValue.materialColor,
      filterWatchValue.price,
      column,
      type,
      filterWatchValue.gemstone
    );
  };

  function formatMoney(amount) {
    try {
      if (amount && amount.toString().includes(".")) {
        var dottedamount = amount.split(".");
        var amount =
          Number(dottedamount[0]).toLocaleString("en-US") +
          "." +
          dottedamount[1];
      } else {
        var amount = Number(amount).toLocaleString("en-US");
      }
      return amount;
    } catch (e) {
      console.log(e);
    }
  }

  const handleOpenDetailsModal = (row) => {
    setSelectedRowDetails(row);
    setVisible(true);
  };

  const handleImgClick = (src) => {
    setModalImgSrc(src);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setModalImgSrc("");
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const onSearch = (value) => {
    setSearchValue(value);
    handleViewALLProduct(
      1,
      pageSize,
      dealerId,
      filterWatchValue.category,
      filterWatchValue.vendor,
      filterWatchValue.materialType,
      filterWatchValue.genderSelect,
      filterWatchValue.collectionSelect,
      filterWatchValue.materialColor,
      filterWatchValue.price,
      sortColumnName,
      sortType,
      filterWatchValue.gemstone,
      value
    );
  };
  const clearSearchFilter = () => {
    setProductCategoryList([]);
    setCollectionList([]);
    setGendersList([]);
    //setImageList(responseData.jewelryHasImages);
    setMetalColorsList([]);
    setMetalTypesList([]);
    setVendorsList([]);
    setGemstoneList([]);
    handleGetJewelryDataList(dealerId.toString(), "", "", "");
  };
  const handleGetJewelryDataList = (id, val, name, Imageset) => {
    let inputData = {
      orderby: "GFInventoryID",
      order: "ASC",
      dealerID: id,
      dealerType: "JewelrySearch",
      category:
        filterWatchValue.category.length > 0
          ? filterWatchValue.category.toString()
          : "",
      vendor:
        filterWatchValue.vendor.length > 0
          ? filterWatchValue.vendor.toString()
          : "",
      materialType:
        filterWatchValue.materialType.length > 0
          ? filterWatchValue.materialType.toString()
          : "",
      gender:
        filterWatchValue.genderSelect.length > 0
          ? filterWatchValue.genderSelect.toString()
          : "",
      collection:
        filterWatchValue.collectionSelect.length > 0
          ? filterWatchValue.collectionSelect.toString()
          : "",
      collectionID: "",
      materialColor:
        filterWatchValue.materialColor.length > 0
          ? filterWatchValue.materialColor.toString()
          : "",
      minRange:
        priceValueChange == false
          ? ""
          : priceValue[0]
          ? priceValue[0].toString()
          : "",
      maxRange:
        priceValueChange == false
          ? ""
          : priceValue[1]
          ? priceValue[1].toString()
          : "9999999",
      styleNumber: "",
      noOfRows: "50",
      offset: "0",
      gemstoneType:
        filterWatchValue.gemstone.length > 0
          ? filterWatchValue.gemstone.toString()
          : "",
      FlgComm_VR: "",
      image: "true",
      minRange: priceValue ? priceValue[0].toString() : "",
      maxRange: priceValue ? priceValue[1].toString() : "",
      strSelectedInvID: "",
    };

    try {
      CatalogJewelryDataService.GetJewelryDataList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData.result;
          if (message === "Success") {
            //setProductCategoryList(categoryList);
            if (name == "category") {
              setProductCategoryList(categoryList); //categoryList
              setCollectionList(responseData.jewelryCollections); //collectionsList
              setGendersList(responseData.jewelryGenders); //gendersList
              setMetalColorsList(responseData.jewelryMetalColors); //metalColorsList
              setMetalTypesList(responseData.jewelryMetalTypes); //metalTypesList
              setVendorsList(responseData.vendorBrand); //vendorsList
              setGemstoneList(responseData.jewelryGemstoneTypes); //gemstoneTypesList
            }
            if (name == "materialType") {
              setProductCategoryList(responseData.jewelryCategory); //categoryList
              setCollectionList(responseData.jewelryCollections); //collectionsList
              setGendersList(responseData.jewelryGenders); //gendersList
              setMetalColorsList(responseData.jewelryMetalColors); //metalColorsList
              setMetalTypesList(metalTypesList); //metalTypesList
              setVendorsList(responseData.vendorBrand); //vendorsList
              setGemstoneList(responseData.jewelryGemstoneTypes); //gemstoneTypesList
            }
            if (name == "genderSelect") {
              setProductCategoryList(responseData.jewelryCategory); //categoryList
              setCollectionList(responseData.jewelryCollections); //collectionsList
              setGendersList(gendersList); //gendersList
              setMetalColorsList(responseData.jewelryMetalColors); //metalColorsList
              setMetalTypesList(responseData.jewelryMetalTypes); //metalTypesList
              setVendorsList(responseData.vendorBrand); //vendorsList
              setGemstoneList(responseData.jewelryGemstoneTypes); //gemstoneTypesList
            }
            if (name == "vendor") {
              setProductCategoryList(responseData.jewelryCategory); //categoryList
              setCollectionList(responseData.jewelryCollections); //collectionsList
              setGendersList(responseData.jewelryGenders); //gendersList
              setMetalColorsList(responseData.jewelryMetalColors); //metalColorsList
              setMetalTypesList(responseData.jewelryMetalTypes); //metalTypesList
              setVendorsList(vendorsList); //vendorsList
              setGemstoneList(responseData.jewelryGemstoneTypes); //gemstoneTypesList
            }
            if (name == "materialColor") {
              setProductCategoryList(responseData.jewelryCategory); //categoryList
              setCollectionList(responseData.jewelryCollections); //collectionsList
              setGendersList(responseData.jewelryGenders); //gendersList
              setMetalColorsList(metalColorsList); //metalColorsList
              setMetalTypesList(responseData.jewelryMetalTypes); //metalTypesList
              setVendorsList(responseData.vendorBrand); //vendorsList
              setGemstoneList(responseData.jewelryGemstoneTypes); //gemstoneTypesList
            }
            if (name == "gemstone") /*gemstoneType*/  { 
              setProductCategoryList(responseData.jewelryCategory); //categoryList
              setCollectionList(responseData.jewelryCollections); //collectionsList
              setGendersList(responseData.jewelryGenders); //gendersList
              setMetalColorsList(responseData.jewelryMetalColors); //metalColorsList
              setMetalTypesList(responseData.jewelryMetalTypes); //metalTypesList
              setVendorsList(responseData.vendorBrand); //vendorsList
              setGemstoneList(gemstoneList); //gemstoneTypesList
            }

            if (name == "collectionSelect") {
              var tempAttributesSets = [
                ...new Set(
                  collectionList.map(
                    ({ collectionLabelValues }) => collectionLabelValues
                  )
                ),
              ];
              setAttributesSets(tempAttributesSets);
              setProductCategoryList(responseData.jewelryCategory); //categoryList
              setCollectionList(collectionList); //collectionList
              setGendersList(responseData.jewelryGenders); //gendersList
              setMetalColorsList(responseData.jewelryMetalColors); //metalColorsList
              setMetalTypesList(responseData.jewelryMetalTypes); //metalTypesList
              setVendorsList(responseData.vendorBrand); //vendorsList
              setGemstoneList(responseData.jewelryGemstoneTypes); //gemstoneTypesList
            } else {
              console.log(responseData.jewelryCollections);
              var tempAttributesSets = [
                ...new Set(
                  responseData.jewelryCollections.map(
                    ({ collectionLabelValues }) => collectionLabelValues
                  )
                ),
              ];
              setAttributesSets(tempAttributesSets);
            }

            if (name == "") {
              setProductCategoryList(responseData.jewelryCategory); //categoryList
              setCollectionList(responseData.jewelryCollections); //collectionList
              setGendersList(responseData.jewelryGenders); //gendersList
              setMetalColorsList(responseData.jewelryMetalColors); //metalColorsList
              setMetalTypesList(responseData.jewelryMetalTypes); //metalTypesList
              setVendorsList(responseData.vendorBrand); //vendorsList
              setGemstoneList(responseData.jewelryGemstoneTypes); //gemstoneTypesList

              var tempAttributesSets = [
                ...new Set(
                  responseData.jewelryCollections.map(
                    ({ collectionLabelValues }) => collectionLabelValues
                  )
                ),
              ];
              setAttributesSets(tempAttributesSets);
            }
          } else {
            clearSearchFilter();
          }
        })
        .catch((error) => {
          console.log(error);
          //setApplyFilterLoading(false);
        });
    } catch (error) {
      console.log(error);
      //setApplyFilterLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="allprod_section jwlsrch__section form__fields">
        <div className="row">
          <div className="col-md-12">
            <div ref={tableTopRef} className="filter_section relative p-0 m-0">
              <div className="col-md-12 d-flex-sm-block_jewelry">
                <div className="gview__div gview__div__jewelry__search">
                  <span
                    className={
                      viewItem === "grid"
                        ? "fa fa-th grid_icon active"
                        : "fa fa-th grid_icon"
                    }
                    onClick={() => handleViewChange("grid")}
                  ></span>
                  <span
                    className={
                      viewItem === "list"
                        ? "fa fa-th-list list_icon active"
                        : "fa fa-th-list list_icon"
                    }
                    onClick={() => handleViewChange("list")}
                  ></span>
                  <h4 className="workarea__heading mt-0 mb-0 ml-2">
                    {t("Jewelry Search")}
                  </h4>
                </div>
                <div className="d-flex-sm-block_search">
                  <Col
                    sm={24}
                    md={16}
                    mb-mobile
                    flex-align-center
                    className="mr-desktop"
                  >
                    <div className="search__bar mr-2px">
                      <Search
                        placeholder={t("Keyword Or SKU")}
                        allowClear
                        onSearch={(value) => onSearch(value.trim())}
                        style={{}}
                      />
                    </div>
                  </Col>
                  <div className="filtbtn__div">
                    <button
                      className="primary-btn"
                      onClick={handleHideShowFilter}
                    >
                      <img src={Filter_icon} alt="" width="14px" />
                      {hideShowFilter ? (
                        <span>
                          {" "}
                          {t("Filter")} <i className="fa fa-angle-down"></i>
                        </span>
                      ) : (
                        <span>
                          {" "}
                          {t("Filter")} <i className="fa fa-angle-up"></i>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-md-12 relative">
                <div
                  className={
                    hideShowFilter
                      ? "form__fields filter_inpsection hide"
                      : "form__fields filter_inpsection"
                  }
                >
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-3 col-md-6">
                        <div className="input__block">
                          <label> {t("Category")} </label>
                          <Select
                            className="border__grey"
                            placeholder={t("Select Category")}
                            showSearch
                            mode="multiple"
                            value={filterWatchValue.category || []}
                            onChange={(e) => onChangeMultiDrop(e, "category")}
                            optionFilterProp="children"
                          >
                            {categoryList.length > 0 ? (
                              <Option> {t("Any")} </Option>
                            ) : null}

                            {categoryList &&
                              categoryList.map((item) => {
                                return (
                                  <Option
                                    value={item.jewelryCategoryID}
                                    key={item.jewelryCategoryID}
                                  >
                                    {item.jewelryCategoryValues}
                                  </Option>
                                );
                              })}
                          </Select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="input__block">
                          <label> {t("Material Type")} </label>
                          <Select
                            className="border__grey"
                            showSearch
                            mode="multiple"
                            placeholder={t("Select Material Type")}
                            optionFilterProp="children"
                            value={filterWatchValue.materialType || []}
                            onChange={(e) =>
                              onChangeMultiDrop(e, "materialType")
                            }
                          >
                            {metalTypesList.length > 0 ? (
                              <Option> {t("All")} </Option>
                            ) : null}

                            {metalTypesList &&
                              metalTypesList.map((item) => {
                                return (
                                  <Option
                                    value={item.metalTypeID}
                                    key={item.metalTypeID}
                                  >
                                    {item.metalTypeValues}
                                  </Option>
                                );
                              })}
                          </Select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="input__block">
                          <label>
                            {" "}
                            {t("Gender")}
                            <Tooltip placement="right" title={gender}>
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Select
                            className="border__grey"
                            showSearch
                            mode="multiple"
                            placeholder={t("Select Gender")}
                            optionFilterProp="children"
                            value={filterWatchValue.genderSelect || []}
                            onChange={(e) =>
                              onChangeMultiDrop(e, "genderSelect")
                            }
                          >
                            {gendersList.length > 0 ? (
                              <Option> {t("All")} </Option>
                            ) : null}

                            {gendersList &&
                              gendersList.map((item) => {
                                return (
                                  <Option
                                    value={item.genderID}
                                    key={item.genderID}
                                  >
                                    {item.genderValues}
                                  </Option>
                                );
                              })}
                          </Select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="input__block">
                          <label> {t("Vendor")} </label>
                          <Select
                            className="border__grey"
                            showSearch
                            mode="multiple"
                            placeholder={t("Select Vendor")}
                            optionFilterProp="children"
                            value={filterWatchValue.vendor || []}
                            onChange={(e) => onChangeMultiDrop(e, "vendor")}
                          >
                            {vendorsList.length > 0 ? (
                              <Option> {t("All")} </Option>
                            ) : null}

                            {vendorsList &&
                              vendorsList.map((item) => {
                                return (
                                  <Option
                                    value={item.vendorNameID}
                                    key={item.vendorNameID}
                                  >
                                    {item.vendorNameValue}
                                  </Option>
                                );
                              })}
                          </Select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="input__block">
                          <label> {t("Material Color")} </label>
                          <Select
                            className="border__grey"
                            showSearch
                            mode="multiple"
                            placeholder={t("Select Material Color")}
                            optionFilterProp="children"
                            value={filterWatchValue.materialColor || []}
                            onChange={(e) =>
                              onChangeMultiDrop(e, "materialColor")
                            }
                          >
                            {metalColorsList.length > 0 ? (
                              <Option> {t("All")} </Option>
                            ) : null}

                            {metalColorsList &&
                              metalColorsList.map((item) => {
                                return (
                                  <Option
                                    value={item.metalColorID}
                                    key={item.metalColorID}
                                  >
                                    {item.metalColorValues}
                                  </Option>
                                );
                              })}
                          </Select>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="input__block">
                          <label> {t("Gemstone")} </label>
                          <Select
                            showSearch
                            mode="multiple"
                            className="border__grey"
                            placeholder={t("Select Gemstone")}
                            optionFilterProp="children"
                            value={filterWatchValue.gemstone || []}
                            onChange={(e) => onChangeMultiDrop(e, "gemstone")}
                            // onSearch={onSearch}
                            // allowClear
                          >
                            {console.log("Gemstone List:", gemstoneList)}
                            {gemstoneList.length > 0 ? (
                              <Option> {t("All")} </Option>
                            ) : null}

                            {gemstoneList.map((item, i) => {
                              return (
                                <Option value={item.gemstoneTypeID}>
                                  {item.gemstoneTypeValues}
                                </Option>
                              );
                            })}
                          </Select>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="input__block">
                          <label>
                            {" "}
                            {t("Collection")}
                            <Tooltip placement="right" title={collection}>
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Select
                            className="border__grey"
                            showSearch
                            mode="multiple"
                            placeholder={t("Select Collection")}
                            optionFilterProp="children"
                            value={filterWatchValue.collectionSelect || []}
                            onChange={(e) =>
                              onChangeMultiDrop(e, "collectionSelect")
                            }
                          >
                            {collectionList.length > 0 ? (
                              <Option> {t("All")} </Option>
                            ) : null}

                            {AttributesSets?.map((item, i) => {
                              return (
                                <OptGroup label={item}>
                                  {collectionList
                                    ?.filter(
                                      (x) => x.collectionLabelValues == item
                                    )
                                    .map((item, j) => {
                                      return (
                                        <Option
                                          value={item.collectionID}
                                          key={(item.collectionID + i + j)}
                                        >
                                          {item.collectionNamesValues}
                                        </Option>
                                      );
                                    })}
                                </OptGroup>
                              );
                            })}
                          </Select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="sliderrange__maindiv">
                          <label> {t("MSRP")} </label>
                          <div className="col-md-12 mt-3">
                            <Slider
                              range
                              value={priceValue}
                              min={filterWatchValue.priceMin}
                              max={priceSliderMax}
                              onChange={(e) => {
                                setPriceValueChange(true);
                                setPriceValue(e);

                                {
                                  btnValue == 1
                                    ? setFilterBtnVisble(false)
                                    : setFilterBtnVisble(true);
                                }
                              }}
                            />
                            <div className="rangeSlider__values">
                              <div className="input__block">
                                <input
                                  type="text"
                                  value={
                                    currencySymbol + formatMoney(priceValue[0])
                                  }
                                  onChange={(e) => {
                                    firstSliderPriceValue(e, 0);
                                  }}
                                />
                              </div>
                              <div>
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>
                              <div className="input__block">
                                <input
                                  type="text"
                                  value={
                                    currencySymbol + formatMoney(priceValue[1])
                                  }
                                  onChange={(e) => {
                                    firstSliderPriceValue(e, 1);
                                  }}
                                  onKeyPress={onKeyPressEvent1}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 filtbtn_div">
                        <button
                          className="primary-btn mr-2"
                          onClick={resetFilters}
                        >
                          {" "}
                          {t("Reset Filters")}{" "}
                        </button>
                        <button className="primary-btn" onClick={applyFilters}>
                          {" "}
                          {t("Apply Filters")}{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {viewItem === "grid" && (
                <React.Fragment>
                  <Spin spinning={loading} size="large">
                    <div className="col-md-12">
                      <div className="prod__section">
                        <div className="row">
                          {/*--------------- Grid view product card starts--------------- */}
                          {viewALLProductList.map((item) => {
                            return (
                              <div
                                className="col-lg-2__5 col-md-6 mt-2"
                                key={item.gfInventoryID}
                              >
                                <div
                                  className="prod__maindiv"
                                  style={{ minHeight: "20rem" }}
                                >
                                  <div className="prodimg__div">
                                    <img src={item.imagepath} alt="" />
                                  </div>
                                  <div className="details__div">
                                    <span className="style__txt">
                                      {item.productName}
                                    </span>
                                    <span className="price__txt">
                                      {item.msrp && item.msrp !== "" && item.msrp !== "N/A" && !isNaN(parseFloat(item.msrp)) ? (
                                        <>
                                          {currencySymbol} {parseFloat(item.msrp).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,",")}
                                        </>
                                      ) : (
                                        "-"
                                      )}
                                    </span>
                                  </div>

                                  {!state.productChange[item.gfInventoryID] ? (
                                    <div
                                      className="info__div"
                                      onClick={() => {
                                        handleProductChangeOpen(
                                          item.gfInventoryID
                                        );
                                      }}
                                    >
                                      <img src={Info_icon} alt="" />
                                    </div>
                                  ) : (
                                    <div className="descr__div">
                                      <div className="product-list overlay__block">
                                        <p>
                                          <span> {t("Dealer Stock #")} </span>
                                          <span>:</span>
                                          <span>{item.styleNumber}</span>
                                        </p>
                                        <p>
                                          <span> {t("Category")}</span>
                                          <span>:</span>
                                          <span>{item.categoryName}</span>
                                        </p>
                                        <p>
                                          <span> {t("Collection")}</span>
                                          <span>:</span>
                                          <span>{item.collectionName}</span>
                                        </p>
                                        <p>
                                          <span> {t("Vendor")}</span>
                                          <span>:</span>
                                          <span>{item.vendorName}</span>
                                        </p>
                                        <p>
                                          <span> {t("MSRP")}</span>
                                          <span>:</span>
                                          <span>
                                            {item.msrp && item.msrp !== "" && item.msrp !== "N/A" && !isNaN(parseFloat(item.msrp)) ? (
                                              <>
                                                {currencySymbol}{" "}
                                                {parseFloat(item.msrp).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,",")}
                                              </>
                                            ) : (
                                              "-"
                                            )}
                                          </span>
                                        </p>

                                        <p>
                                          <span> {t("Metal Type")}</span>
                                          <span>:</span>
                                          <span>{item.metalType}</span>
                                        </p>
                                        <p>
                                          <span> {t("Metal Color")}</span>
                                          <span>:</span>
                                          <span>{item.metalColor}</span>
                                        </p>
                                      </div>
                                      <div
                                        className="close__div"
                                        onClick={() =>
                                          handleProductChangeClose(
                                            item.gfInventoryID
                                          )
                                        }
                                      >
                                        <img src={Close} alt="" />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })}

                          {/* Grid view product card ends */}
                        </div>
                      </div>
                    </div>
                    <div className="flex-end">
                      <Pagination
                        style={{ marginTop: "30px" }}
                        total={jewelryTotalRecords}
                        current={pageNo}
                        pageSize={pageSize}
                        pageSizeOptions={[10, 20, 50, 100]}
                        responsive={true}
                        showSizeChanger={true}
                        onChange={handlePageNoChange}
                        onShowSizeChange={handlePageSizeChange}
                        showTotal={(total, range) => (
                          <div className="pagination-total">{`${range[0]}-${range[1]} of ${total} jewelery`}</div>
                        )}
                      />
                    </div>
                  </Spin>
                </React.Fragment>
              )}
              {viewItem === "list" && (
                <div className="col-md-12 mt-4">
                  <div className="jewelry__search_table">
                    <Table
                      key={key}
                      bordered={true}
                      columns={[
                        // {
                        //   title: "",
                        //   dataIndex: "view",
                        //   width: window.innerWidth > 768 ? 40 : 40,
                        //   render: (item, row) => {
                        //     return (
                        //       <React.Fragment>
                        //         <div
                        //           className="infoicon__div"
                        //           onClick={() => handleOpenDetailsModal(row)}
                        //         >
                        //           <i className="fa fa-info-circle"></i>
                        //         </div>
                        //       </React.Fragment>
                        //     );
                        //   },
                        // },
                        {
                          title: "",
                          dataIndex: "imagepath",
                          width: window.innerWidth > 768 ? 40 : 40,
                          render: (item, row) => {
                            return (
                              <React.Fragment>
                                <div>
                                  {row.imagepath !== "" ? (
                                    <img
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        setSelectedColumnId(row?.styleNumber);
                                        handleImgClick(row?.imagepath);
                                      }}
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                      }}
                                      src={row?.imagepath}
                                      alt=""
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </React.Fragment>
                            );
                          },
                        },
                        {
                          title: (
                            <Tooltip title={t("Dealer Stock #")}>
                              {t("Dealer Stock #")}
                            </Tooltip>
                          ),
                          onCell: () => ({
                            onClick: (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            },
                          }),
                          ellipsis: true,
                          dataIndex: "styleNumber",
                          showSorterTooltip: false,
                          sorter: (a, b) => {},
                          ellipsis: true,
                        },
                        {
                          title: (
                            <Tooltip title={t("Category")}>
                              {t("Category")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "categoryName",
                          showSorterTooltip: false,
                          ellipsis: true,
                        },
                        {
                          title: (
                            <Tooltip title={t("Vendor")}>{t("Vendor")}</Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "vendorName",
                          showSorterTooltip: false,
                          sorter: (a, b) => {},
                          render: (text, record) => (
                            <span
                              className="linkText"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleViewMore(record?.dealerID);
                              }}
                            >
                              {text}
                            </span>
                          ),
                        },
                        {
                          title: (
                            <Tooltip title={t("Collection")}>
                              {t("Collection")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "collectionName",
                          showSorterTooltip: false,
                          ellipsis: true,
                        },
                        {
                          title: (
                            <Tooltip title={t("MSRP")}>
                              {t("MSRP")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "MSRP",
                          showSorterTooltip: false,
                          sorter: (a, b) => {},
                          render: (item, row) => {
                            return (
                              <p>
                                {row.msrp && row.msrp !== "" && row.msrp !== "N/A" && !isNaN(parseFloat(row.msrp))
                                  ? currencySymbol + " " + parseFloat(row.msrp).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                  : "-"}
                              </p>
                            );
                          },
                        },
                      ]}
                      dataSource={viewALLProductList}
                      pagination={{
                        size: "small",
                        total: jewelryTotalRecords,
                        pageNo: pageNo,
                        current: pageNo,
                        pageSize: pageSize,
                        pageSizeOptions: [10, 15, 20, 50, 100],
                        responsive: true,
                        showSizeChanger: true,
                        showTotal: (total, range) => (
                          <div className="pagination-total">{`${range[0]}-${range[1]} of ${total} jewelry`}</div>
                        ),
                      }}
                      onRow={(record, recordIndex) => ({
                        onClick: (event) => {
                          setSelectedColumnId(record?.styleNumber);

                          handleOpenDetailsModal(record);
                        },
                      })}
                      rowClassName={(record) =>
                        record.styleNumber == selectedColumnId
                          ? "row-active"
                          : ""
                      }
                      loading={loading}
                      onChange={handleTableASCDES}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <Modal
          title={t("View Details")}
          className="modalvdiamond__section"
          centered
          visible={visible}
          onOk={handleCancel}
          onCancel={handleCancel}
          width={900}
          footer={[
            <Button key="back" onClick={handleCancel}>
              {t("Cancel")}
            </Button>,
          ]}
        >
          <div className="col-lg-12">
            <div className="modal__body">
              <div className="col-lg-12">
                <div className="form__fields border-0 p-0">
                  <div className="row">
                    <div
                      className="col-lg-24 dk-flex-sm-block"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      <div className="col-lg-2 col-sm-24 mt-4 text-center">
                        <div className="viewdtls__left">
                          <img
                            style={{ width: "100px" }}
                            src={selectedRowDetails.imagepath}
                            alt=""
                          />
                        </div>
                      </div>

                      <div
                        className="info__div col-lg-18"
                        style={{
                          display: "flex",
                          gap: "16px",
                          flexWrap: "wrap",
                          flex: 1,
                        }}
                      >
                        <div
                          style={{
                            borderRight: "1px solid #ccc",
                            paddingRight: "16px",
                            flex: 1,
                          }}
                        >
                          <p>
                            <span className="head__txt">
                              {t("Dealer Stock #")}:
                            </span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.styleNumber}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">{t("Category")}:</span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.categoryName}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">
                              {t("Collection")}:
                            </span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.collectionName}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">
                              {t("Metal Type")}:
                            </span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.metalType}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">
                              {t("Metal Color")}:
                            </span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.metalColor}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">{t("MSRP")}:</span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.msrp && selectedRowDetails.msrp !== "" && selectedRowDetails.msrp !== "N/A" && !isNaN(parseFloat(selectedRowDetails.msrp))
                                ? `${currencySymbol} ${parseFloat(selectedRowDetails.msrp).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                                : "-"}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">
                              {t("Gemstone Type")}:
                            </span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.gemstoneType}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">
                              {t("Gemstone Shape")}:
                            </span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.gemstoneShape}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">
                              {t("Diamond Weight")}:
                            </span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.gemstoneWeight}
                            </span>
                          </p>
                        </div>

                        <div
                          style={{
                            backgroundColor: "#f5f5f5",
                            paddingLeft: "16px",
                            flex: 1,
                          }}
                        >
                          <p>
                            <span className="head__txt">{t("Vendor")}:</span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.vendorName}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">{t("Phone")}:</span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.dealerPhone}
                            </span>
                          </p>
                          <p>
                            <span className="head__txt">{t("Dealer ID")}:</span>{" "}
                            <span className="val__txt">
                              {selectedRowDetails.dealerID}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <div className="jewelery_image_modal">
          <Modal
            visible={isModalVisible}
            footer={null}
            onCancel={handleModalClose}
            centered
            className="jewelery_image_modal image-modal"
          >
            <img
              src={modalImgSrc}
              alt="Enlarged"
              style={{ width: "100%", height: "100%" }}
            />
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
};
export default JewelrySearch;
